import { render, staticRenderFns } from "./ConfirmAddress.vue?vue&type=template&id=3ad6969b&scoped=true"
import script from "./ConfirmAddress.vue?vue&type=script&lang=js"
export * from "./ConfirmAddress.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAddress.vue?vue&type=style&index=0&id=3ad6969b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad6969b",
  null
  
)

export default component.exports